import { render, staticRenderFns } from "./orderScanning.vue?vue&type=template&id=c39835e6&"
import script from "./orderScanning.vue?vue&type=script&lang=js&"
export * from "./orderScanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports